import ManageDataService from '../Services/ManageDataService';

export const getSessionUsageMasterData = () => async (dispatch) => {
    try {
        const res = await ManageDataService.getSessionUsageMasterData();
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};
export const getStaffTimeMasterData = () => async (dispatch) => {
    try {
        const res = await ManageDataService.getStaffTimeMasterData();
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const getDeliveryStaffProductivityMasterData = () => async (dispatch) => {
    try {
        const res = await ManageDataService.getDeliveryStaffProductivityMasterData();
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const getStaffCostDeptMasterData = () => async (dispatch) => {
    try {
        const res = await ManageDataService.getStaffCostDeptMasterData();
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const getServiceDistributionMasterData = () => async (dispatch) => {
    try {
        const res = await ManageDataService.getServiceDistributionMasterData();
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const getExternalCostsMasterData = () => async (dispatch) => {
    try {
        const res = await ManageDataService.getExternalCostsMasterData();
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const getOverheadCostsMasterData = () => async (dispatch) => {
    try {
        const res = await ManageDataService.getOverheadCostsMasterData();
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const getWebCostsMasterData = () => async (dispatch) => {
    try {
        const res = await ManageDataService.getWebCostsMasterData();
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const getProductMarginMasterData = () => async (dispatch) => {
    try {
        const res = await ManageDataService.getProductMarginMasterData();
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const getProductPricingModelMasterData = () => async (dispatch) => {
    try {
        const res = await ManageDataService.getProductPricingModelMasterData();
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const getRRCIAndTrainingPricingMasterData = () => async (dispatch) => {
    try {
        const res = await ManageDataService.getRRCIAndTrainingPricingMasterData();
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const getAdditionalCounselingPricingMasterData = () => async (dispatch) => {
    try {
        const res = await ManageDataService.getAdditionalCounselingPricingMasterData();
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};
export const getPathwaysPricingTableMasterData = () => async (dispatch) => {
    try {
        const res = await ManageDataService.getPathwaysPricingTableMasterData();
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const getGWQPricingMasterData = () => async (dispatch) => {
    try {
        const res = await ManageDataService.getGWQPricingMasterData();
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const getNPRTWPricingMasterData = () => async (dispatch) => {
    try {
        const res = await ManageDataService.getNPRTWPricingMasterData();
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const getCurrencyMasterData = () => async (dispatch) => {
    try {
        const res = await ManageDataService.getCurrencyMasterData();
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const getEnhancedLandFAvailabilityMasterData = () => async (dispatch) => {
    try {
        const res = await ManageDataService.getEnhancedLandFAvailabilityMasterData();
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const saveSessionUsageMasterData = (SessionUsageMasterData) => async (dispatch) => {
    try {
        const res = await ManageDataService.saveSessionUsageMasterData(SessionUsageMasterData);
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const saveStaffTimeMasterData = (StaffTimeMasterData) => async (dispatch) => {
    try {
        const res = await ManageDataService.saveStaffTimeMasterData(StaffTimeMasterData);
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const saveDeliveryStaffProductivityMasterData = (DeliveryStaffProductivityMasterData) => async (dispatch) => {
    try {
        const res = await ManageDataService.saveDeliveryStaffProductivityMasterData(DeliveryStaffProductivityMasterData);
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const saveStaffCostDeptMasterData = (StaffCostDeptMasterData) => async (dispatch) => {
    try {
        const res = await ManageDataService.saveStaffCostDeptMasterData(StaffCostDeptMasterData);
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const saveServiceDistributionMasterData = (ServiceDistributionMasterData) => async (dispatch) => {
    try {
        const res = await ManageDataService.saveServiceDistributionMasterData(ServiceDistributionMasterData);
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const saveExternalCostsMasterData = (ExternalCostsMasterData) => async (dispatch) => {
    try {
        const res = await ManageDataService.saveExternalCostsMasterData(ExternalCostsMasterData);
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const saveOverheadCostsMasterData = (OverheadCostsMasterData) => async (dispatch) => {
    try {
        const res = await ManageDataService.saveOverheadCostsMasterData(OverheadCostsMasterData);
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const saveWebCostasterData = (WebCostasterData) => async (dispatch) => {
    try {
        const res = await ManageDataService.saveWebCostasterData(WebCostasterData);
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const saveProductMarginMasterData = (ProductMarginMasterData) => async (dispatch) => {
    try {
        const res = await ManageDataService.saveProductMarginMasterData(ProductMarginMasterData);
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const saveProductPricingModelMasterData = (ProductPricingModelMasterData) => async (dispatch) => {
    try {
        const res = await ManageDataService.saveProductPricingModelMasterData(ProductPricingModelMasterData);
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const saveRRCIAndTrainingMasterData = (RRCIAndTrainingMasterData) => async (dispatch) => {
    try {
        const res = await ManageDataService.saveRRCIAndTrainingMasterData(RRCIAndTrainingMasterData);
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const saveAdditionalCounselingPricingMasterData = (AdditionalCounselingPricingMasterData) => async (dispatch) => {
    try {
        const res = await ManageDataService.saveAdditionalCounselingPricingMasterData(AdditionalCounselingPricingMasterData);
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const savePathwaysPricingTableMasterData = (PathwaysPricingTableMasterData) => async (dispatch) => {
    try {
        const res = await ManageDataService.savePathwaysPricingTableMasterData(PathwaysPricingTableMasterData);
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const saveGWQPricingMasterData = (GWQPricingMasterData) => async (dispatch) => {
    try {
        const res = await ManageDataService.saveGWQPricingMasterData(GWQPricingMasterData);
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const saveNPRTWPricingMasterData = (NPRTWPricingMasterData) => async (dispatch) => {
    try {
        const res = await ManageDataService.saveNPRTWPricingMasterData(NPRTWPricingMasterData);
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const saveCurrencyMasterData = (CurrencyMasterData) => async (dispatch) => {
    try {
        const res = await ManageDataService.saveCurrencyMasterData(CurrencyMasterData);
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};export const saveEnhancedLandFAvailabilityMasterData = (EnhancedLandFAvailabilityMasterData) => async (dispatch) => {
    try {
        const res = await ManageDataService.saveEnhancedLandFAvailabilityMasterData(EnhancedLandFAvailabilityMasterData);
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};
